
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface CertificateFiltersProps {
  stateFilter: string | undefined;
  setStateFilter: (value: string | undefined) => void;
  courseTypeFilter: string | undefined;
  setCourseTypeFilter: (value: string | undefined) => void;
  reportingStatusFilter: string | undefined;
  setReportingStatusFilter: (value: string | undefined) => void;
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  onRefresh: () => void;
}

export function CertificateFilters({
  stateFilter,
  setStateFilter,
  courseTypeFilter,
  setCourseTypeFilter,
  reportingStatusFilter,
  setReportingStatusFilter,
  searchQuery,
  setSearchQuery,
  onRefresh
}: CertificateFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-4">
      <div className="flex-1">
        <Input
          placeholder="Search certificate numbers..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <div className="flex flex-wrap gap-2">
        <Select
          value={stateFilter || "all"}
          onValueChange={(value) => setStateFilter(value === "all" ? undefined : value)}
        >
          <SelectTrigger className="w-[120px]">
            <SelectValue placeholder="All States" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All States</SelectItem>
            <SelectItem value="FL">Florida</SelectItem>
            <SelectItem value="CA">California</SelectItem>
            <SelectItem value="TX">Texas</SelectItem>
            <SelectItem value="NY">New York</SelectItem>
          </SelectContent>
        </Select>
        
        <Select
          value={courseTypeFilter || "all"}
          onValueChange={(value) => setCourseTypeFilter(value === "all" ? undefined : value)}
        >
          <SelectTrigger className="w-[120px]">
            <SelectValue placeholder="All Types" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Types</SelectItem>
            <SelectItem value="BDI">BDI</SelectItem>
            <SelectItem value="ADI">ADI</SelectItem>
            <SelectItem value="DDC">DDC</SelectItem>
            <SelectItem value="TDC">TDC</SelectItem>
          </SelectContent>
        </Select>

        <Select
          value={reportingStatusFilter || "all"}
          onValueChange={(value) => setReportingStatusFilter(value === "all" ? undefined : value)}
        >
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="Reporting Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            <SelectItem value="reported">Reported</SelectItem>
            <SelectItem value="unreported">Unreported</SelectItem>
          </SelectContent>
        </Select>
        
        <Button variant="outline" onClick={onRefresh}>
          Refresh
        </Button>
      </div>
    </div>
  );
}
